import React, { createContext, useReducer, useContext, useEffect } from "react";
import { addHistoryAction, getUserHistory } from "../api/history";
import { AuthContext } from "./AuthContext";
import isEqual from "lodash/isEqual";

export const HistoryContext = createContext();

const historyReducer = (state = [], action) => {
  switch (action.type) {
    case "SET_HISTORY":
      return Array.isArray(action.payload) ? action.payload : [];
    case "ADD_ACTION":
      return [...state, action.payload];
    case "CLEAR":
      return [];
    default:
      return state;
  }
};

export function HistoryProvider({ children }) {
  const [history, dispatch] = useReducer(historyReducer, []);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (user?.id) {
      getUserHistory()
        .then(data => dispatch({ type: "SET_HISTORY", payload: data }))
        .catch(err => console.error("Erreur récupération historique:", err));
    } else {
      dispatch({ type: "CLEAR", payload: {} })
    }
  }, [user?.id]);

  const addAction = async (action) => {
    try {
      const payload = setActionPayload(action)
      if ( shoudAddAction(payload) ) {
        dispatch({ type: "ADD_ACTION", payload });
        await addHistoryAction(payload);
        return [...history, payload]
      } else {
        return history
      }
    } catch (err) {
      console.error("Erreur ajout historique:", err);
    }
  };

  const shoudAddAction = (payload) => {
    if ( history )
      return !history.some(item => isEqual(item, payload));
    else
      return true
  }

  const setActionPayload = (action) => {
    let metadata = {}
    let content = ''
    const values = action.values
    const ciaov2_job_id = values?.id !== 'lux' ? (values?.jobId || values?.id) : null
    const type = action.type
    let from = "depuis le tableau de bord"
    if ( values?.from === 'job_detail')
      from = "depuis la fiche détail"
    else if ( values?.from == 'lux')
      from = "par l'intermédiaire de Lux"

    let gender = 'un'
    if ( values?.gender === 'girl')
      gender  ='une'

    if ( type === 'QUIZZ_STARTED') {
      content = `Le jeune a démarré le quizz pour le métier de ${values.title} ${from}.`
    } else if ( type === 'GRIT_AND_FIT_STARTED') {
      content = `Le jeune a démarré le grit and fit pour le métier de ${values.title} ${from}.`
    } else if ( type === 'EXPERT_CHAT_STARTED') {
      content = `Le jeune commence une discussion ${from} avec ${values.name}, ${gender} ${values.title}.`
    } else if ( type === 'Lux_STARTED') {
      content = `Le jeune commence la discussion avec Lux.`
    } else if ( type === 'Lux_ASK_FEEDBACK') {
      content = `Lux a demandé un feedback au jeune après son échange avec ${values.name} dont le métier est ${values.title}.`
    } else if ( type === 'Lux_TO_EXPERT') {
      content = `Lux a mis le jeune en contact avec le métier de ${values.title}.`
    } else if ( type === 'BACK_FROM_EXPERT') {
      content = `${values.expert_name}, ${values.expert_job}, a redonné la main à Lux.`
    } else if ( type === 'QUIZZ_ENDED') {
      content = `Le jeune a terminé le quizz pour le métier de ${values.title} avec un score de ${values.score} / 100.`
      metadata = {score: values.score}
    } else if ( type === 'JOB_PAGE') {
      content = `Le jeune a parcouru la fiche du métier de ${values.title}.`
    } else if ( type === 'GRIT_AND_FIT_SCENARIO_STARTED') {
      content = `Le jeune a commencé le scénario ${values.num_scenario} pour le métier de ${values.title}.`
    } else if ( type === 'GRIT_AND_FIT_SCENARIO_ENDED') {
      content = `Le jeune a terminé le scénario ${values.num_scenario} pour le métier de ${values.title}.`
    } else if ( type === 'VALUES_SURVEY_STARTED') {
      content = `Le jeune a commencé le questionnaire sur les valeurs.`
    } else if ( type === 'VALUES_SURVEY_COMPLETED') {
      content = `Le jeune a terminé le questionnaire sur les valeurs.`
    } else if ( type === 'RIASEC_SURVEY_STARTED') {
      content = `Le jeune a commencé le questionnaire RIASEC.`
    } else if ( type === 'RIASEC_SURVEY_COMPLETED') {
      content = `Le jeune a terminé le questionnaire RIASEC.`
    } else if ( type === 'JOURDA_SURVEY_STARTED') {
      content = `Le jeune a commencé le questionnaire JOURDA.`
    } else if ( type === 'JOURDA_SURVEY_COMPLETED') {
      content = `Le jeune a terminé le questionnaire JOURDA.`
    } else if ( type === 'IM_SURVEY_STARTED') {
      content = `Le jeune a commencé le questionnaire sur les intelligences multiples.`
    } else if ( type === 'IM_SURVEY_COMPLETED') {
      content = `Le jeune a terminé le questionnaire sur les intelligences multiples.`
    } else if ( type === 'LUX_CONVERSATION') {
      content = `Le jeune a parlé à LUX.`
    } else if ( type === 'DIP_CONVERSATION') {
      content = `Le jeune a parlé à DIP.`
    } else if ( type === 'SUP_CONVERSATION') {
      content = `Le jeune a parlé à SUP.`
    }
    return {content, ciaov2_job_id, type, metadata}
  }

  const getHistory = (jobId = null) => {
    if ( jobId )
      return history.filter((h) => h.ciaov2_job_id == jobId).map(item => item.content).join("\n")
    return history.map(item => item.content).join("\n")
  }

  const getHistoryObj = (jobId = null) => {
    if ( jobId )
      return history.filter((h) => h.ciaov2_job_id == jobId)
    return history
  }

  const clearHistory = async () => {
    dispatch({ type: "CLEAR" });
  };

  return (
    <HistoryContext.Provider value={{ history, addAction, getHistory, getHistoryObj, clearHistory }}>
      {children}
    </HistoryContext.Provider>
  );
}
